import { AddAlert } from '../../../../component';

import {
  buildCoordinatesReverse,
  removeEmptyFromResponse,
} from '../../../../shared/utils';

import { loading, loaded } from '../../../../layout/redux/layoutActions';

import {
  getInfoWindow,
  getBuildingDetails,
  getBigNumbersPrimary,
} from './offersPrimary.infra';

import {
  updateRequestStatus,
  updateInputIntervalsPrimary,
  closeInfowindowsPrimary,
  updateBuildingData,
  updateDisplayBigNumbersOffersPrimary,
  setInfowindowsPrimary,
  updateChartsDataPrimary,
  storeChartData,
  clearStoragedChartDataPrimary,
} from './offersPrimary.actions';

import {
  modalOpen,
  setDisplayCharts,
  setIsLoadingMap,
} from '../../redux/dashboardActions';

import {
  addIWListener,
  createOpenInfoWindow,
  generateMarkersOnMap,
} from './offersPrimary.map';

import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';
import { setRealtyType } from '../../charts/redux/charts.actions';

import { generalMarketsPayloadAdapter } from '../../../../shared/adapters';

let loadingStateController = {
  bigNumbers: false,
  companies: false,
};

const fieldsDictionary = {
  privateAreaIntervalmin: 'Área Privativa Inicial',
  privateAreaIntervalmax: 'Área Privativa Final',
  unitPricemin: 'Faixa de preço da Unidade Inicial',
  unitPricemax: 'Faixa de preço da Unidade Final',
  pricePerSquareMtmin: 'Faixa de preço/m² Inicial',
  pricePerSquareMtmax: 'Faixa de preço/m² Final',
  realtyAgemin: 'Idade do Imóvel Inicial',
  realtyAgemax: 'Idade do Imóvel Final',
};

export const searchRealtyOffersPrimary = (payload, cityId) => {
  const DISPLAY_CHART_KEY = 'primaryMarketGeneral';

  const formattedPayload = generalMarketsPayloadAdapter(
    payload,
    cityId,
    'primary'
  );

  return (dispatch) => {
    dispatch([
      generateBigNumbersPrimary(formattedPayload),
      // setDisplayCharts(DISPLAY_CHART_KEY),
    ]);
  };
};

export const handlePriceInputs = (e, v, tuple, type) => {
  let name;
  let maskedValue = '';
  const replaceDots = e.value.replaceAll('.', '').split('R$');
  const valueAsFloat =
    replaceDots.length === 2
      ? parseInt(replaceDots[1])
      : parseInt(replaceDots[0]);
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    tuple.min = maskedValue;
    name = e.name.split('min')[0];
  } else {
    tuple.max = maskedValue;
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: tuple,
  };
  return (dispatch) => {
    dispatch(updateInputIntervalsPrimary(payload));
  };
};

export const handleInputsIntervals = (e, v, tuple, type, typeNumber) => {
  return (dispatch) => {
    let name;
    if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return;
    if (!e.value.match(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/) && e.value.length > 0) {
      return;
    }

    if (e.name.includes('min')) {
      tuple.min =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
      name = e.name.split('min')[0];
    } else {
      name = e.name.split('max')[0];
      tuple.max =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
    }
    const payload = {
      name,
      value: tuple,
    };

    dispatch(updateInputIntervalsPrimary(payload));
  };
};

export const validateForm = (
  formData,
  validation,
  type,
  moreFilters,
  isBuildingFilter = false,
  cityId
) => {
  let flag = false;

  return (dispatch) => {
    if (!formData.realtyType.id) {
      dispatch(AddAlert('warning', 'Tipo de imóvel é um campo obrigatório'));
      flag = true;
    }

    if (!Object.values(validation)?.every((el) => el === false)) {
      const removedFalses = Object.entries(validation).filter(
        (el) => el[1] !== false
      );
      const errors = removedFalses.map((el) => fieldsDictionary[el[0]]);
      const invalidFields = errors.join(', ');
      const isPlural = errors.length > 1;

      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${invalidFields}`
        )
      );

      flag = true;
    }

    if (!flag) {
      dispatch(
        payloadBuilder(
          formData,
          null,
          type,
          !!isBuildingFilter,
          false,
          undefined,
          cityId
        )
      );
    }
  };
};

export const generateInfoWindow = (rgi, marker, coordinates) => {
  const timeframeData = localStorage.getItem('TimeFrame');
  const timeframe =
    timeframeData && timeframeData !== 'undefined'
      ? JSON.parse(timeframeData)
      : '';

  const payload = timeframe
    ? {
        rgi,
        timeframe,
      }
    : {
        rgi,
      };

  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getInfoWindow(coordinates))
      .then((res) => {
        dispatch(closeInfowindowsPrimary());
        const iw = createOpenInfoWindow({ data: res?.data, marker, rgi });
        dispatch(setInfowindowsPrimary(iw));
        dispatch(addIWListener(payload));
      })
      .catch((err) => console.error(err))
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generateBuildingDetailsModal = (payload) => {
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getBuildingDetails(payload))
      .then((res) => {
        dispatch(updateBuildingData(res.data));
        dispatch(modalOpen('open building'));
      })
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generatePrimaryMarketGeneralCharts = (chartData) => {
  return (dispatch) => {
    dispatch([
      loading(),
      updateRequestStatus({ name: 'launchedUnits', value: 'LOADING' }),
      updateRequestStatus({
        name: 'launchedUnitsEcoMapPercentile',
        value: 'LOADING',
      }),
    ]);

    if (chartData) {
      dispatch([
        updateChartsDataPrimary({
          name: 'eco_map',
          value: chartData,
        }),
        updateRequestStatus({ name: 'launchedUnits', value: 'LOADED' }),
        updateRequestStatus({
          name: 'launchedUnitsEcoMapPercentile',
          value: 'LOADED',
        }),
        dispatch(loaded()),
      ]);
    } else {
      dispatch([
        updateRequestStatus({ name: 'launchedUnits', value: 'FAILED' }),
        updateRequestStatus({
          name: 'launchedUnitsEcoMapPercentile',
          value: 'FAILED',
        }),
        dispatch(loaded()),
      ]);
    }
  };
};

export const generateBigNumbersPrimary = (payload) => {
  return (dispatch) => {
    dispatch([loading(), clearStoragedChartDataPrimary()]);

    Promise.resolve(getBigNumbersPrimary(payload))
      .then((response) => {
        if (response?.data) {
          const { pins, big_numbers, releases_sales_info } = response?.data;

          const displayChartKey = 'primaryMarketGeneral';
          const markerType = 'primary';
          const realtyType = payload?.realty_type;

          if (releases_sales_info) {
            dispatch(storeChartData(releases_sales_info));
          }

          const bigNumbersDTO = {
            total_releases_ads: big_numbers?.total_releases,
            total_units: big_numbers?.total_units,
            units_sold_percentage: big_numbers?.units_sold_percentage,
            stock: big_numbers?.stock,
          };

          const bigNumbers = removeEmptyFromResponse(bigNumbersDTO);

          dispatch([
            generateMarkersOnMap(pins, markerType),
            setBigNumbers(bigNumbers),
            setRealtyType(realtyType),
            setDisplayCharts(displayChartKey),
            updateDisplayBigNumbersOffersPrimary(true),
            setIsLoadingMap(false),
          ]);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        dispatch([loaded(), setIsLoadingMap(false)]);
        loadingStateController.bigNumbers = true;
        if (loadingStateController.companies) {
          loadingStateController.bigNumbers = false;
          loadingStateController.companies = false;
        }
      });
  };
};

export const payloadBuilder = (
  data,
  moreFilters,
  type,
  isBuildingFilter = false,
  isUpdate = false,
  filterType = '',
  cityId
) => {
  const location = buildCoordinatesReverse();

  const newData = {
    ...data,
    ...data?.inputIntervals,
  };

  if (!location && !isBuildingFilter) {
    return (dispatch) => {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
    };
  } else {
    const bedrooms = newData.bedrooms
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const suites = newData.suites
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const garages = newData.garages
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const payload = moreFilters
      ? {
          location,
          ...newData,
          bedrooms,
          suites,
          garages,
          moreFilters,
        }
      : {
          location,
          ...newData,
          bedrooms,
          suites,
          garages,
        };

    return (dispatch) => {
      dispatch([searchRealtyOffersPrimary(payload, cityId)]);
    };
  }
};
